module.exports = "<div [style.backgroundColor]=\"backgroundColor\">\n  <div [style.backgroundColor]=\"backgroundColor\">\n    <div class=\"container\" [style.backgroundColor]=\"backgroundColor\">\n      <div class=\"row\">\n        <div class=\"logo-container-form\">\n          <img class=\"logo-login\" src=\"assets/images/merci.png\"/>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/merci/merci.component.html
// module id = ../../../../../src/app/merci/merci.component.html
// module chunks = main